import { isElectronApp } from '../services/crossPlatform/crossPlatformService';
import routerHistory from '../routerHistory';
import { ROUTES } from '../const';

export const shouldRedirect = redirectUrl => {
  return redirectUrl && !isElectronApp();
};

/**
 * Redirects to the given url. If the url is empty or is Electron, it navigates
 * to the home page.
 * @param redirectUrl Url to redirect.
 * @returns {Promise<unknown>} Promise that resolves when the redirect is done.
 */
export const redirect = async redirectUrl => {
  return new Promise(resolve => {
    if (shouldRedirect(redirectUrl)) {
      const url = new URL(redirectUrl);
      window.location.href = url.href;
      resolve();
    } else {
      routerHistory.push(ROUTES.HOME);
      resolve();
    }
  });
};

export const removeQueryParam = (url, param) => {
  const urlObj = new URL(url);
  urlObj.searchParams.delete(param);
  return urlObj.href;
};

export const addQueryParam = (url, param, value) => {
  const urlObj = new URL(url);
  urlObj.searchParams.set(param, value);
  return urlObj.href;
};
